export function logErrorsToServer() {
  window.onerror = (message, url, lineNumber) => {
    const request = {
      error: message,
      pageUrl: window.location.href,
      lineNumber: lineNumber,
      jsFile: url,
    };

    fetch("/ds-logging/log-warning", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    }).catch((error) => console.error("Error logging to server", error));

    return false;
  };
};
